import React, { memo } from 'react'
import clsx from 'clsx'
import { Box, Dialog, Fade, Grid, List } from '@material-ui/core'
import YouTubeIcon from '@material-ui/icons/YouTube'
import Image from '@v4/components/common/Image'
import EditableHTML from '@v4/components/common/EditableHTML'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import SortHandler from '@v4/components/common/SortHandler'
import Item from './components/Item'
import VideoBlock from '../../../Video/components/VideoBlock'
import { useBanner14 } from './Banner14.hooks'

const Banner14 = props => {
	const [
		{
			classes,
			withBgImage,
			backgroundImage,
			open,
			video,
			withModal,
			items,
			gridItemContent,
			gridItemIcon,
			mobileAlignment,
			direction,
			textShadow,

			text,
			textConfig,
			textKey,
			textEditable,

			buttonText,
			buttonLink,
			buttonAction,
			buttonTextConfig,
			buttonTextEditable,
			buttonTextKey,
		},
		{
			handleToggleModal,
			handleTextClick,
			handleButtonClick,
			handleImageClick,
			handleTextChange,
			handleButtonTextChange,
		},
	] = useBanner14(props)

	return (
		<>
			<Grid className={clsx(classes.root, 'banner14-root')} container>
				{withBgImage && (
					<Image
						className={clsx(classes.background, 'banner14-background-image')}
						metaData={backgroundImage}
						onClick={handleImageClick}
						isBackground
					/>
				)}
				<SortHandler direction={direction}>
					<Grid
						className={clsx(classes.grid, 'banner14-grid')}
						item
						md={gridItemContent}
						lg={gridItemContent}
						xs={12}
					>
						<Box className={clsx(classes.wrapper, 'banner14-wrapper')}>
							<EditableContainer
								visible={!!text}
								white={withBgImage}
								fieldConfig={textConfig}
								onAdd={handleTextChange}
								editable={textEditable}
							>
								<EditableHTML
									key={textKey}
									className={clsx(classes.text, 'banner14-text')}
									gutterBottom
									white={withBgImage}
									html={text}
									onClick={handleTextClick}
									onChange={handleTextChange}
									editable={textEditable}
									shadow={withBgImage}
									textShadow={textShadow}
								/>
							</EditableContainer>
							<EditableContainer
								visible={!!buttonText}
								white={withBgImage}
								fieldConfig={buttonTextConfig}
								onAdd={handleButtonTextChange}
								editable={buttonTextEditable}
								label="Button"
								wrapper={({ children }) => (
									<Box className={clsx(classes.buttonWrap, 'banner11-button-wrapper')}>
										{children}
									</Box>
								)}
							>
								<ActionButton
									key={buttonTextKey}
									action={buttonAction}
									href={buttonLink}
									className={clsx(classes.button, 'banner14-button')}
									onClick={handleButtonClick}
									editable={buttonTextEditable}
									onChange={handleButtonTextChange}
								>
									{buttonText}
								</ActionButton>
							</EditableContainer>
						</Box>
					</Grid>
					<Grid className={clsx(classes.grid, 'banner14-grid')} item md={gridItemIcon} lg={gridItemIcon}>
						<Box
							onClick={withModal ? handleToggleModal : undefined}
							className={clsx(withModal && classes.withVideo, 'banner14-background')}
						>
							{withModal && <YouTubeIcon className={clsx(classes.icon, 'banner14-icon')} />}
						</Box>
					</Grid>
					<Grid
						className={clsx(classes.grid, 'banner14-grid')}
						item
						md={gridItemContent}
						lg={gridItemContent}
					>
						{!_.isEmpty(items) && (
							<List className={clsx(classes.list, 'banner14-list')}>
								{_.map(items, (key, index) => (
									<Item
										key={key}
										itemKey={key}
										group="items"
										index={index}
										isWhite={withBgImage}
										mobileAlignment={mobileAlignment}
									/>
								))}
							</List>
						)}
					</Grid>
				</SortHandler>
			</Grid>
			<Dialog
				open={open && withModal}
				onClose={handleToggleModal}
				maxWidth="md"
				PaperProps={{ className: classes.modal }}
				className="banner14-modal"
			>
				<Fade in={open && withModal}>
					<VideoBlock className="banner14-block" value={video} />
				</Fade>
			</Dialog>
		</>
	)
}

Banner14.propTypes = {
	metaData: PropTypes.shape({
		text: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		backgroundImage: PropTypes.instanceOf(PageMetaData),
		contentWidth: PropTypes.instanceOf(PageMetaData),
		backgroundRounding: PropTypes.instanceOf(PageMetaData),
		backgroundImagePosition: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Banner14)
